import { apiGet } from '../_common';

export default {
  getInvoiceById(id) {
    return apiGet(`/magenta/billing/invoice/${id}`)
      .then(result => result.response);
  },
};
